export class EquipmentList {
    public equipmentId: number;
    public equipmentSerialNo: string;
    public equipmentUnitNo: string;

    public equipmentSMU: number;
}

export class AttachImplementModalData {
    public implementId: number;
    public jobsiteId: number;
    public equipmentId: number;
    public smu: number;
    public cost: number;
    public date: Date;
    public comment: string;
}